import { render, staticRenderFns } from "./groupsAdmin.vue?vue&type=template&id=5c7d08c4&scoped=true&"
import script from "./groupsAdmin.vue?vue&type=script&lang=js&"
export * from "./groupsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./groupsAdmin.vue?vue&type=style&index=0&id=5c7d08c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d08c4",
  null
  
)

export default component.exports